// NIGHT-DIRECTSTAFF-2026-10-22 §11: "What they've told us" on the candidate header -- the agents window's candidate memory
// (agent_conversations.memory, jsonb, written by recruiter-agent src/memory.js from their own messages by fixed rules),
// READ-ONLY here, with the date it last changed. "Wrong?" opens a staff note (activity_log, type 'memory_note'); the
// memory itself is never edited from the CRM. Until the hub applies the agents window's 2026-10-22-conversation-memory.sql
// the column is absent from the conversation rows and nothing shows.
import React, { useState } from 'react';

export const MEMORY_LABELS = { disciplines: 'Discipline', states: 'States wanted', regions: 'Regions', settings: 'Settings', earliest_start: 'Earliest start',
  pay_expectation: 'Pay (their words)', licenses: 'Licenses mentioned', do_not_contact: 'Do not contact' };
export const MEMORY_NOTE_TYPE = 'memory_note';
const national = (v) => { const d = String(v || '').replace(/\D/g, ''); return d.length === 11 && d.startsWith('1') ? d.slice(1) : d; };

/** The memory on the candidate's thread(s) (their number), merged newest first. -> { rows: [{ key, label, value }], updatedAt } | null */
export function memoryFor(candidate, conversations = []) {
  const p = national(candidate && candidate.phone);
  if (p.length !== 10) return null;
  const mems = (conversations || []).filter((c) => national(c.candidate_phone) === p && c.memory && typeof c.memory === 'object')
    .map((c) => c.memory).sort((a, b) => String(b.updated_at || '').localeCompare(String(a.updated_at || '')));
  if (!mems.length) return null;
  const rows = [];
  for (const [key, label] of Object.entries(MEMORY_LABELS)) {
    const vals = [];
    for (const m of mems) { const v = m[key]; for (const x of Array.isArray(v) ? v : v ? [v] : []) { const s = String(x).trim(); if (s && !vals.includes(s)) vals.push(s); } }
    if (vals.length) rows.push({ key, label, value: vals.join(', ') });
  }
  return rows.length ? { rows, updatedAt: mems[0].updated_at || null } : null;
}

/** candidate; conversations (with memory once the column exists); saveNote(candidateId, text) -> Promise; toast */
export default function CandidateMemory({ candidate, conversations = [], saveNote, toast = () => {} }) {
  const [noting, setNoting] = useState(false);
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  const mem = memoryFor(candidate, conversations);
  if (!mem) return null;
  const save = async (e) => {
    e.preventDefault();
    if (!text.trim()) return;
    setBusy(true);
    try { await saveNote(candidate.id, text.trim()); toast('Note saved. The memory itself is unchanged.'); setNoting(false); setText(''); }
    catch (err) { toast(err.message || 'Not saved'); } finally { setBusy(false); }
  };
  return (
    <div data-testid="cand-memory" style={{ marginTop: 10, background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 8, padding: '8px 12px' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <strong style={{ fontSize: 13, color: '#0f172a' }}>What they've told us</strong>
        <span data-testid="cand-memory-updated" style={{ fontSize: 12, color: '#475569' }}>{mem.updatedAt ? `last changed ${new Date(mem.updatedAt).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}` : ''}</span>
      </div>
      <dl style={{ display: 'grid', gridTemplateColumns: 'max-content 1fr', gap: '2px 10px', margin: '4px 0 0', fontSize: 13 }}>
        {mem.rows.map((r) => <React.Fragment key={r.key}><dt style={{ color: '#475569' }}>{r.label}</dt><dd data-testid={`cand-memory-${r.key}`} style={{ margin: 0, color: '#0f172a', overflowWrap: 'anywhere' }}>{r.value}</dd></React.Fragment>)}
      </dl>
      {!noting ? (
        <button className="nb" data-testid="cand-memory-wrong" onClick={() => setNoting(true)}
          style={{ marginTop: 4, background: 'transparent', color: '#1d4ed8', fontSize: 13, fontWeight: 700, minHeight: 44, padding: '0 4px', border: 0 }}>Wrong?</button>
      ) : (
        <form data-testid="cand-memory-note" onSubmit={save} style={{ display: 'grid', gap: 6, marginTop: 6 }}>
          <label htmlFor="cand-memory-text" style={{ fontSize: 12, fontWeight: 700, color: '#334155' }}>What's wrong? (a staff note on their timeline; the memory isn't edited)</label>
          <input id="cand-memory-text" data-testid="cand-memory-text" className="input" value={text} maxLength={500} onChange={(e) => setText(e.target.value)} style={{ minHeight: 44, fontSize: 14 }} />
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="nb" type="submit" data-testid="cand-memory-save" disabled={busy || !text.trim()} style={{ background: '#166534', color: 'white', borderRadius: 8, padding: '0 14px', minHeight: 44, fontWeight: 700, border: 0, opacity: busy || !text.trim() ? 0.55 : 1 }}>Save note</button>
            <button className="nb" type="button" onClick={() => setNoting(false)} style={{ background: '#f1f5f9', color: '#475569', borderRadius: 8, padding: '0 14px', minHeight: 44, fontWeight: 700, border: 0 }}>Cancel</button>
          </div>
        </form>
      )}
    </div>
  );
}
